import { StatsigClient, _getInstance } from '@statsig/react-bindings';
import type { PrecomputedEvaluationsInterface } from '@statsig/react-bindings';

import createStatsigUser from './utils/createStatsigUser';
import getClientKey from './utils/getClientKey';
import getClientOptions from './utils/getClientOptions';
import getInitialValues from './utils/getInitialValues';

/**
 * Safely access the shared Statsig client instance by key or create new one if doesn't exist for given key.
 * NOTE: since this function needs access to the request context it can't be called in the module scope and needs to be called inside a React component or a hook.
 */
const getClientInstance = () => {
  const clientKey = getClientKey();

  // TODO: ohazda - fix temporary fixed type assertion (not sure what is the difference)
  let instance = _getInstance(clientKey) as PrecomputedEvaluationsInterface;

  if (!instance) {
    // Automatically saves new instance by it clientKey, so subsequent calls to getClientInstance with the same key will return the same instance.
    instance = new StatsigClient(clientKey, createStatsigUser(), getClientOptions());
    instance.dataAdapter.setData(getInitialValues());
    instance.initializeSync();
  }

  return instance;
};

export default getClientInstance;
